import { useDocumentationFeatures } from 'hooks/useDocumentationFeatures'
import { Workspace } from 'types'
import { SettingScreen } from '../types'
import { WORKSPACE_ITEMS } from '../utils'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

export const useWorkspaceNavItems = (workspace: Workspace) => {
  const isVirtualMarketer = workspace.is_virtual_marketer
  const { isDocumentationEnabled } = useDocumentationFeatures()
  const isAPMobileWeb = useAPMobileWeb()

  let workspaceNavItems = WORKSPACE_ITEMS.filter((item) => workspace.admin || !item.admin).filter(
    (item) => !isVirtualMarketer || item.key !== SettingScreen.Properties,
  )

  if (!isDocumentationEnabled) {
    workspaceNavItems = workspaceNavItems.filter((item) => item.key !== SettingScreen.Styles)
  }

  if (isAPMobileWeb) {
    workspaceNavItems = workspaceNavItems.filter((item) => item.key !== SettingScreen.Billing)
  }

  return {
    workspaceNavItems,
  }
}
